import { createSlice } from "@reduxjs/toolkit";

export const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    message: null,
    type: null,
  },
  reducers: {
    setCurrentPageNotification: (state = {}, action) => {
      const { message, type } = action.payload;
      state.message = message;
      state.type = type;
      state.expiration = new Date(new Date().getTime() + 15000).getTime();
    },
    setNextPageNotification: (state = {}, action) => {
      const { message, type } = action.payload;
      state.nextPageMessage = message;
      state.nextPageMessageType = type;
    },
  },
});

export const { setCurrentPageNotification, setNextPageNotification } = notificationSlice.actions;

export const selectNotification = (state) => state.notification;

export default notificationSlice.reducer;
